export default "__VITE_ASSET__6b9b9edf__"